import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

// Tag Sentry events with the current user's numeric id (no email/PII) so a
// single user's errors and traces are searchable when they report an issue.
// Mirrors the backend's Sentry.set_user(id:) so user.id unifies across projects.
// Pass a falsy value (e.g. on logout) to clear the user.
export default function useSentryUser(userId) {
  useEffect(() => {
    Sentry.setUser(userId ? { id: userId } : null);
  }, [userId]);
}
